import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.CatalogItem'

export default defineMessages({
  listPriceLabel: {
    id: `${scope}.listPriceLabel`,
    defaultMessage: 'List:',
  },
  saveBadge: {
    id: `${scope}.saveBadge`,
    defaultMessage: 'Save {pct}%',
  },
  savingsHintOn: {
    id: `${scope}.savingsHintOn`,
    defaultMessage: 'on {label}',
  },
  quantityAriaLabel: {
    id: `${scope}.quantityAriaLabel`,
    defaultMessage: 'Item quantity',
  },
  addToRequestButton: {
    id: `${scope}.addToRequestButton`,
    defaultMessage: 'Add to my request',
  },
})
